export enum EPreviewLineType {
  None = 0,
  Text,
  Spacer,
  Answer,
  CheckBox,
  CheckBoxCorrect,
}

export interface PreviewLine {
  text: string;
  type: EPreviewLineType;
}

export class PreviewLines extends Array<PreviewLine> {
  constructor() {
    super();
  }

  add(text: string, type: EPreviewLineType = EPreviewLineType.None): void {
    this.push({ text, type });
  }
}
